import React from 'react'

export default function AddProblemOverlay() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        left: 0,
        top: 0,
        width: '100vw',
        height: '100vh',
        cursor: 'crosshair',
        zIndex: 999999999999999,
      }}
    ></div>
  )
}
